import { render, staticRenderFns } from "./ProfessorEvaluations.vue?vue&type=template&id=2514ef90&scoped=true"
import script from "./ProfessorEvaluations.vue?vue&type=script&lang=js"
export * from "./ProfessorEvaluations.vue?vue&type=script&lang=js"
import style0 from "./ProfessorEvaluations.vue?vue&type=style&index=0&id=2514ef90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514ef90",
  null
  
)

export default component.exports